import React, { useState } from 'react';
import './Login.css';
import AdminNav from '../../pages/AdminNav/AdminNav';
import { RiUser3Line, RiLockPasswordLine, RiEyeLine, RiEyeOffLine, RiArrowRightLine, RiShieldCheckLine, RiLoader4Line } from 'react-icons/ri';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.success) {
        onLogin(data.token, data.admin);
      } else {
        setError(data.message || 'Invalid credentials. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please make sure the backend is running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AdminNav />
      <div className="login-page">
        {/* Background grid decoration */}
        <div className="login-bg-grid" aria-hidden="true" />
        <div className="login-bg-glow" aria-hidden="true" />

        <div className="login-card">

          {/* Left accent bar */}
          <div className="login-card__accent" aria-hidden="true" />

          {/* Header */}
          <div className="login-header">
            <div className="login-header__icon">
              <RiShieldCheckLine size={26} />
            </div>
            <div>
              <p className="login-header__eyebrow">BaiRees Global Advisory</p>
              <h1 className="login-header__title">Admin Portal</h1>
              <p className="login-header__sub">Sign in to access your dashboard</p>
            </div>
          </div>

          {/* Divider */}
          <div className="login-divider" aria-hidden="true" />

          {/* Form */}
          <form onSubmit={handleSubmit} className="login-form" noValidate>

            {/* Username */}
            <div className="login-field">
              <label className="login-field__label" htmlFor="username">Username</label>
              <div className="login-field__input-wrap">
                <span className="login-field__icon"><RiUser3Line size={16} /></span>
                <input
                  id="username"
                  type="text"
                  className="login-field__input"
                  value={username}
                  onChange={(e) => { setUsername(e.target.value); if (error) setError(''); }}
                  placeholder="Enter your username"
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div className="login-field">
              <label className="login-field__label" htmlFor="password">Password</label>
              <div className="login-field__input-wrap">
                <span className="login-field__icon"><RiLockPasswordLine size={16} /></span>
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  className="login-field__input"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); if (error) setError(''); }}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="login-field__toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <RiEyeOffLine size={16} /> : <RiEyeLine size={16} />}
                </button>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div className="login-error" role="alert">
                <span className="login-error__dot" aria-hidden="true" />
                {error}
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              className="login-submit"
              disabled={loading || !username || !password}
            >
              {loading ? (
                <>
                  <RiLoader4Line size={17} className="login-submit__spin" />
                  Signing in…
                </>
              ) : (
                <>
                  Sign In
                  <RiArrowRightLine size={17} className="login-submit__arrow" />
                </>
              )}
            </button>
          </form>

          {/* Footer */}
          <p className="login-footer">
            Credentials are configured in your <code>.env</code> file
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;